import { Component, OnInit } from '@angular/core';

import * as Services from '@shared/core/services';
import * as State from '@shared/state';
import { Controllers } from '@shared/core/controllers';

import { ModalViewComponent } from '../modal-view.shared.component';

import { Observable } from 'rxjs';
import { map } from 'rxjs/operators';

@Component({
    selector: 'shared-modal-for-single-product',
    templateUrl: './modal-for-single-product.shared.component.html',
    styleUrls: ['./modal-for-single-product.shared.component.scss'],
})
export class ModalForSingleProductComponent extends ModalViewComponent implements OnInit {
    public singleProduct$: Observable<State.IWizzardSimpleItem>;
    public singleProductImage$: Observable<string>;
    public imageLoading$: Observable<boolean>;
    public singleProductStats$: Observable<OLO.Components.IStatsComponentInput>;
    public singleProductQuantity$: Observable<number>;
    public singleProductTotalValue$: Observable<number>;
    public singleProductUnitPrice$: Observable<number>;
    public singleProductTagImages$: Observable<State.IDietaryTagImage[]>;
    public showContent$: Observable<boolean>;
    public hasSpecialInstructions$: Observable<boolean>;

    constructor(public modalsService: Services.ModalsService, public heightAdjustService: Services.HeightAdjustService, public controllers: Controllers) {
        super(modalsService, heightAdjustService, null);
    }

    ngOnInit(): void {
        this.singleProduct$ = this.controllers.wizzard.wizzardSimpleItem$();
        this.singleProductImage$ = this.controllers.wizzard.wizzardSimpleItemImage$();
        this.imageLoading$ = this.controllers.wizzard.wizzardItemImageLoading$();
        this.singleProductQuantity$ = this.controllers.wizzard.wizzardSimpleItemQuantity$();
        this.singleProductUnitPrice$ = this.controllers.wizzard.wizzardSimpleItemUnitPrice$();
        this.singleProductTotalValue$ = this.controllers.wizzard.wizzardSimpleItemTotalValue$();
        this.singleProductStats$ = this.controllers.wizzard.wizzardSimpleItemStats$();
        this.singleProductTagImages$ = this.controllers.wizzard.wizzardSimpleItemTagsImages$();
        this.showContent$ = this.controllers.wizzard.showWizardWrapper$(this.modalData.type);
        this.hasSpecialInstructions$ = this.controllers.wizzard.wizzardSimpleItem$().pipe(map((product) => product?.Tags?.map((p) => p.Name).includes('SpecialInstruction')));

        this.dimmedBg = true;
        this.minHeight = 100;
        this.shadow = true;
    }

    public handleSingleProductIncrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        this.controllers.wizzard.wizzardSimpleItemIncrement();
    }

    public handleSingleProductDecrement($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        this.controllers.wizzard.wizzardSimpleItemDecrement();
    }

    public handleSingleProductRemove($event: OLO.Components.Quantity.IQuantityOutputEvent): void {
        this.controllers.wizzard.wizzardSimpleItemDecrement();
    }

    public handleSingleProductCtaClick($event: Event): void {
        this.controllers.wizzard.wizzardSimpleItemAddToCart(this.modalData.id, this.modalData.locationNo);
    }
}
